import { render, staticRenderFns } from "./else.vue?vue&type=template&id=49f510da&scoped=true&"
import script from "./else.vue?vue&type=script&lang=js&"
export * from "./else.vue?vue&type=script&lang=js&"
import style0 from "./else.vue?vue&type=style&index=0&id=49f510da&prod&lang=scss&"
import style1 from "./else.vue?vue&type=style&index=1&id=49f510da&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f510da",
  null
  
)

export default component.exports